import React from 'react';
import PropTypes from 'prop-types';

export default function SourceSelector(props) {
    const {datasources, selectedDatasource, onChange} = props;

    return (
        <select
            id="Data-Source"
            name="Data-Source"
            data-name="Data Source"
            className="select-field w-select"
            value={selectedDatasource}
            onChange={ev => onChange(ev.target.value)}
        >
            {datasources.length ?
                datasources.map(({name, label}) => <option value={name} key={name}>{label}</option>) :
                <option disabled>Loading...</option>
            }
        </select>
    );
}

SourceSelector.propTypes = {
    datasources: PropTypes.array.isRequired,
    selectedDatasource: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
